module.exports = __webpack_public_path__ + "static/media/CG.c2f55ad5.svg";